import React, { useState, useEffect, useRef } from 'react';
import { Sparkles } from 'lucide-react';

interface LoadingStateProps {
  title?: string;
  minHeight?: string;
}

const FUNNY_SERIOUS_MESSAGES = [
  "Summoning conveners and members... Please hold your chai! ☕",
  "Counting attendees and double-checking who showed up... 📋",
  "Brewing fresh meeting analytics... just a second! 📊",
  "Politely asking the database to send all records... 🚀",
  "Verifying meeting minutes & roll call status... ⏱️",
  "Gathering state records from across the chambers... 🌐",
  "Checking attendance logs... no slipping away unnoticed! 📝",
  "Crunching numbers and attendance percentages... 📈",
  "Reticulating meeting splines... almost ready! ✨",
  "Making sure nobody faked their attendance... 🕵️",
  "Fetching data faster than a chai break... ☕🏃",
  "Almost there... just convincing the server to cooperate! 🤝"
];

export default function LoadingState({ title = "Loading data...", minHeight = "min-h-[250px]" }: LoadingStateProps) {
  const [messageIndex, setMessageIndex] = useState(() =>
    Math.floor(Math.random() * FUNNY_SERIOUS_MESSAGES.length)
  );
  const [fade, setFade] = useState(true);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      timeoutRef.current = setTimeout(() => {
        setMessageIndex((prev) => (prev + 1) % FUNNY_SERIOUS_MESSAGES.length);
        setFade(true);
      }, 300);
    }, 3000);

    return () => {
      clearInterval(interval);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <div className={`flex flex-col items-center justify-center p-8 text-center bg-white rounded-xl border border-gray-100 shadow-sm ${minHeight}`}>
      <div className="relative mb-5">
        <div className="h-14 w-14 rounded-full border-[3.5px] border-blue-100 border-t-blue-600 animate-spin"></div>
        <Sparkles className="absolute -top-1.5 -right-1.5 text-blue-500 animate-pulse" size={16} />
      </div>

      <h4 className="text-base font-bold text-gray-900 mb-2">{title}</h4>

      <p className={`text-xs sm:text-sm text-gray-500 max-w-xs transition-opacity duration-300 ease-in-out ${fade ? 'opacity-100' : 'opacity-0'}`}>
        {FUNNY_SERIOUS_MESSAGES[messageIndex]}
      </p>
    </div>
  );
}
